<h1 mat-dialog-title>Gear Access for: {{label}}</h1>
<button mat-icon-button mat-dialog-close test-id="close">
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content class="fill-width">
  <span *ngIf="!isLoadingProjects && hasHiddenProjects && isRestricted && (isSiteAdmin || isDeveloper)" class="hidden-selected-projects">
    <mat-icon class="xs">info_outline</mat-icon>
    <ng-container *ngIf="siteAdminHiddenSelectedProjects > 0">
      {{"There are {{0}} project(s) not listed. Enabled 'Manage Site' from the profile menu to see all projects." | interpolate:siteAdminHiddenSelectedProjects }}
    </ng-container>
    <ng-container *ngIf="siteDeveloperHiddenSelectedProjects > 0">
      {{"There are {{0}} project(s) not listed due to a lack of permission. Please contact a site admin for further inquiries, or use the SDK to make changes." | interpolate:siteDeveloperHiddenSelectedProjects }}
    </ng-container>
  </span>

  <form [formGroup]="form">
    <mat-tab-group *ngIf="isRestricted && (isDeveloper || isSiteAdmin)" (selectedTabChange)="onTabChange($event)" mat-stretch-tabs="false">
      <mat-tab>
        <ng-template mat-tab-label #projectsTab>
          <span>Projects</span>
          <span test-id="selected-projects-count"
            class="selected-projects-count"
            [fwTooltip]="selectedProjectLabels.join('\n')">
            ({{ selectedProjectLabels.length }})
          </span>
        </ng-template>

        <div class="table-wrapper">
          <ng-container *ngIf="!isLoadingProjects">
            <table mat-table matSort matSortDisableClear
              [dataSource]="projectRows$"
              [matSortActive]="projectSort$.value.active"
              [matSortDirection]="projectSort$.value.direction"
              (matSortChange)="projectSort$.next($event)">

              <ng-container matColumnDef="checkbox">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox test-id="select-all-projects"
                    [checked]="checkAllState.projects.all"
                    [indeterminate]="checkAllState.projects.some"
                    (change)="selectAllItems($event.checked, 'projects')">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let element" class="text-left">
                  <mat-checkbox [attr.test-id]="'select-project-' + element.projectId"
                    [checked]="tracked.all.projects[element._id]?.selected"
                    (change)="selectItem($event.checked, element._id, 'projects')"
                    (click)="$event.stopPropagation()">
                  </mat-checkbox>
                </td>
              </ng-container>

              <ng-container matColumnDef="label">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="full-width">
                  <fw-text-input
                    test-id="project-filter"
                    placeholder="Projects"
                    [formControl]="projectFilters.controls.projects"
                    (keydown)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()"
                  ></fw-text-input>
                </th>
                <td mat-cell *matCellDef="let element" fwTooltip="{{ element.label }}">
                  <div class="ellipsis">{{ element.label }}</div>
                </td>
              </ng-container>

              <ng-container matColumnDef="parents.group">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="full-width">
                  <fw-multi-select
                    test-id="group-filter"
                    placeholder="Groups"
                    [maxSelectedShown]="0"
                    [options]="groupOptions"
                    [useCheckbox]="true"
                    [closeOnSelect]="false"
                    [filterItemsOnSelect]="false"
                    optionsWidth="fit-content"
                    [showClear]="true"
                    titleProperty="label"
                    (keydown)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()"
                    [formControl]="projectFilters.controls.groups">
                  </fw-multi-select>
                </th>
                <td mat-cell *matCellDef="let element" fwTooltip="{{ element.group }}">
                  <div class="ellipsis">{{ element.group }}</div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="projectsColumns; sticky: true "></tr>
              <tr mat-row *matRowDef="let row; columns: projectsColumns;" class="list-action-hover"></tr>

            </table>
            <div #loadProjectsTrigger (fwLoadTrigger)="loadMore('projects')" class="load-trigger"></div>
          </ng-container>

          <fw-loading *ngIf="isLoadingProjects"></fw-loading>

          <div *ngIf="!isLoadingProjects && !hasProjects && !hasErrorLoadingProjects" class="empty blank-state">
            <mat-icon class="sm raised blue">block</mat-icon>
            <p>No available projects</p>
          </div>

          <div *ngIf="hasErrorLoadingProjects" class="empty blank-state">
            <mat-icon class="sm raised red">priority_high</mat-icon>
            <p>There was an error loading projects</p>
          </div>
        </div>

      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label #usersTab>
          <span>Users</span>
          <span test-id="selected-users-count"
            class="selected-users-count"
            [fwTooltip]="selectedUserLabels.join('\n')">
            ({{ selectedUserLabels.length }})
          </span>
        </ng-template>
        <div class="table-wrapper">
          <table mat-table matSort matSortDisableClear
            [dataSource]="userRows$"
            [matSortActive]="userSort$.value.active"
            [matSortDirection]="userSort$.value.direction"
            (matSortChange)="userSort$.next($event)">

            <ng-container matColumnDef="checkbox">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox test-id="select-all-users"
                  [checked]="checkAllState.users.all"
                  [indeterminate]="checkAllState.users.some"
                  (change)="selectAllItems($event.checked, 'users')">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let element" class="text-left">
                <mat-checkbox [attr.test-id]="'select-user-' + element.userId"
                  [checked]="tracked.all.users[element._id]?.selected"
                  (change)="selectItem($event.checked, element._id, 'users')"
                  (click)="$event.stopPropagation()">
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="user">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="full-width">
                <mat-form-field appearance="outline" class="full-width">
                  <input matInput type="text"
                    test-id="user-filter"
                    placeholder="Users"
                    [formControl]="$any(userFilters.get('users'))"
                    (keydown)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()"
                    autocomplete="off">
                </mat-form-field>
              </th>
              <td mat-cell *matCellDef="let element">
                <app-avatar [users]="usersMap[element._id]" [enablePopover]="true"></app-avatar>
                {{ element.user }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="usersColumns; sticky: true "></tr>
            <tr mat-row *matRowDef="let row; columns: usersColumns;" class="list-action-hover"></tr>

          </table>
          <div #loadUsersTrigger (fwLoadTrigger)="loadMore('users')" class="load-trigger"></div>

          <fw-loading *ngIf="isLoadingUsers"></fw-loading>

          <div *ngIf="!isLoadingUsers && !hasUsers && !hasErrorLoadingUsers" class="empty blank-state">
            <mat-icon class="sm raised blue">block</mat-icon>
            <p>No available users</p>
          </div>

          <div *ngIf="hasErrorLoadingUsers" class="empty blank-state">
            <mat-icon class="sm raised red">priority_high</mat-icon>
            <p>There was an error loading users</p>
          </div>
        </div>

      </mat-tab>

    </mat-tab-group>

    <div class="restrict-access fw-filter-box">
      <div>
        <label [id]="getElementId('restrict-access-label')">
          Restricted Access
          <span class="bright-blue">{{ ('common.labels.' + (isRestricted ? 'on' : 'off')) | translate }}</span>
        </label>
        <p>Turning on restricted access allows you to limit a gear to specific groups, projects, and users you define. Turning off restricted access will open the gear to everyone on your site</p>
      </div>
      <mat-slide-toggle test-id="restrict-access-toggle" formControlName="isRestricted" [aria-labelledby]="getElementId('restrict-access-label')"></mat-slide-toggle>
    </div>
  </form>
</div>
<div mat-dialog-actions class="fill-width">
  <ng-container *ngIf="hasChanged()">
    <button [disabled]="isSaving" test-id="reset-button" color="primary" class="left-action" mat-stroked-button (click)="reset()">Reset Changes</button>
    <button [disabled]="isSaving" test-id="cancel-button" color="primary" mat-stroked-button mat-dialog-close>Cancel</button>
    <button test-id="save-button" color="primary" [ngClass]="{ 'btn-icon': isSaving }" mat-flat-button (click)="save()">
      <mat-spinner *ngIf="isSaving" class="white" [diameter]="16"></mat-spinner>
      Save
    </button>
  </ng-container>
  <button *ngIf="!hasChanged()" test-id="close-button" color="primary" mat-flat-button mat-dialog-close>Close</button>
</div>
